// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"2279": "65353134","5030": "7a88d3df","6707": "ee99207b","7839": "c77c5180","8506": "845ac7ef",}[chunkId] + ".css"
}